package team.platforma.materialextension.sample_screens

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Slider
import androidx.compose.material3.SliderDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableFloatStateOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import team.platforma.multiplatform_material_extension.ui.OutlineSmsCodeInputField

@Composable
fun SmsCodeSample() {

    var itemsCount by remember { mutableFloatStateOf(4f) }

    var itemSize by remember { mutableFloatStateOf(48f) }

    var itemSpase by remember { mutableFloatStateOf(4f) }

    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier.widthIn(max = 400.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            var password by remember { mutableStateOf("") }
            OutlineSmsCodeInputField(
                value = password,
                onValueChange = {
                    password = it
                },
                items = itemsCount.toInt(),
                itemSize = itemSize.toInt().dp,
                itemSpase = itemSpase.toInt().dp,
                validate = {
                },
                autoRequestFocus = false
            )
            Spacer(modifier = Modifier.height(24.dp))

            Text(text = "Размер айтема ${itemSize.toInt()} dp")

            Slider(
                value = itemSize,
                onValueChange = { itemSize = it },
                colors = SliderDefaults.colors(
                    thumbColor = MaterialTheme.colorScheme.secondary,
                    activeTrackColor = MaterialTheme.colorScheme.secondary,
                    inactiveTrackColor = MaterialTheme.colorScheme.secondaryContainer,
                ),
                steps = 28,
                valueRange = 0f..56f
            )

            Spacer(modifier = Modifier.height(8.dp))

            Text(text = "Колличество айтемов ${itemsCount.toInt()}")
            Slider(
                value = itemsCount,
                onValueChange = { itemsCount = it },
                colors = SliderDefaults.colors(
                    thumbColor = MaterialTheme.colorScheme.secondary,
                    activeTrackColor = MaterialTheme.colorScheme.secondary,
                    inactiveTrackColor = MaterialTheme.colorScheme.secondaryContainer,
                ),
                steps = 9,
                valueRange = 1f..10f
            )

            Spacer(modifier = Modifier.height(8.dp))

            Text(text = "Отступы между айтемами ${itemSpase.toInt()} dp")

            Slider(
                value = itemSpase,
                onValueChange = { itemSpase = it },
                colors = SliderDefaults.colors(
                    thumbColor = MaterialTheme.colorScheme.secondary,
                    activeTrackColor = MaterialTheme.colorScheme.secondary,
                    inactiveTrackColor = MaterialTheme.colorScheme.secondaryContainer,
                ),
                steps = 16,
                valueRange = 0f..16f
            )

        }
    }

}